var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.606 1c-5.277 0-9.76 4.058-10.322 9.282C5.057 10.847 1 15.33 1 20.605A10.4 10.4 0 0 0 11.394 31c5.277 0 9.777-4.058 10.322-9.282C26.942 21.153 31 16.67 31 11.395A10.4 10.4 0 0 0 20.606 1zm7.958 11.558a8.086 8.086 0 0 1-6.777 6.778v-6.778h6.778zM3.436 19.442a8.086 8.086 0 0 1 6.778-6.795v6.777H3.435v.018zm15.918 2.345a8.04 8.04 0 0 1-7.96 6.866 8.038 8.038 0 0 1-7.958-6.864h15.918v-.003zm.089-9.229v6.866h-6.884v-6.866h6.884zm9.123-2.345H12.647a8.04 8.04 0 0 1 7.96-6.866 8.037 8.037 0 0 1 7.958 6.864v.003z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGusd);
export default __webpack_public_path__ + "static/media/GUSD.8c9212708fc9892d12dfcc131a2ac873.svg";
export { ForwardRef as ReactComponent };